import { Tooltip, Text, Button, Stack } from '@mantine/core';
import { EVENT_TYPES, EventsByDay } from '../types';
import { EventTooltipContent } from './Calendar.event-tooltip-content';
import { useDesktop } from '@/hooks';
import { IconExclamationCircle } from '@tabler/icons-react';

export const DailyEvents: React.FC<{ date: string; events: EventsByDay }> = ({ date, events }) => {
  const isDesktop = useDesktop();
  const tooltipPosition = isDesktop ? 'right-start' : 'bottom';

  if (!events) {
    return null;
  }

  const eventsForDay = events.get(date);

  return (
    <Stack gap={2} mt="auto" mb="xs" w="100%">
      {EVENT_TYPES.map((type) => {
        const typeEvents = eventsForDay?.[type];
        if (!typeEvents?.count) return null;

        return (
          <Tooltip
            key={type}
            color="white"
            position={tooltipPosition}
            offset={isDesktop ? -10 : 0}
            withArrow
            label={<EventTooltipContent events={typeEvents.events} type={type} />}
            multiline
            arrowOffset={isDesktop ? 10 : 0}
            arrowSize={6}
            p="0"
            maw={{ base: 300, md: 350, lg: 400 }}
          >
            <Button
              component="div"
              tt="capitalize"
              fullWidth
              variant={typeEvents.variant}
              p="0 0 0 4px"
              radius="xs"
              size="compact-xs"
              justify="flex-start"
              leftSection={
                typeEvents.icon ? (
                  <IconExclamationCircle size={14} color={typeEvents.color} />
                ) : null
              }
              styles={{
                section: { marginRight: 4 },
                root: {
                  ...(typeEvents.statusGrade === 2 && {
                    borderLeft: `2px solid ${typeEvents.color}`,
                  }),
                  ...(typeEvents.statusGrade === 4 && {
                    border: `1px solid ${typeEvents.color}`,
                  }),
                },
              }}
              color={
                typeEvents.statusGrade === 2 ||
                typeEvents.statusGrade === 5 ||
                typeEvents.statusGrade === 4
                  ? typeEvents.bg
                  : typeEvents.color
              }
            >
              <Text truncate="end" fz="xs" c={typeEvents.color}>
                {type} {typeEvents.count > 1 ? `(${typeEvents.count})` : ''}
              </Text>
            </Button>
          </Tooltip>
        );
      })}
    </Stack>
  );
};
